import FindologicTracker from './interface';
import func from '../../func';

/**
 * Convenience tracker that does nothing. It's useful because external logic doesn't need to be aware whether a
 * tracker is available or not.
 *
 * @constructor
 * @augments FindologicTracker
 */
export default function DummyTracker(config) {
    FindologicTracker.call(this, config);

    /**
     * Dummy tracker implementation that does nothing but call the callback.
     *
     * @param {string} url
     * @param {string} data
     * @param {function} callback
     */
    this.send = function (url, data, callback) {
        func.undefinedToNoOp(callback)();
    };
}
